import { Component, inject } from '@angular/core';
import { RouterOutlet, RouterLink, RouterLinkActive } from '@angular/router';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { LoginService } from '../../core/services/login.service';
import { Router } from '@angular/router';
import { MatButton, MatFabButton, MatIconButton, MatMiniFabButton } from '@angular/material/button';
import { MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { PrincipalWindowSearch } from '../../components/principal-window-search/principal-window-search';

@Component({
  selector: 'app-main-menu',
  standalone: true,
  imports: [
    RouterOutlet,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatToolbarModule,
    MatFabButton,
    MatIconButton
  ],
  templateUrl: './main-menu.html',
  styleUrl: './main-menu.css',
})
export class MainMenu {

  public sidenavCollapsed = false;
  private _bottomSheet = inject(MatBottomSheet);


  constructor(
    private authService: LoginService,
    private router: Router
  ) {}

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  openPrincipalWindow(): void {
    const ref = this._bottomSheet.open(PrincipalWindowSearch);
    ref.afterDismissed().subscribe((result) => { // primer buscador
      if (result?.idCondominium != null && result?.idHouse != null) {
        this.router.navigate(['/invitation'], {
          queryParams: { idCondominium: result.idCondominium, idHouse: result.idHouse }
        });
      } else if (result?.qrString != null){ // segundo buscador por qrString
        this.router.navigate(['/invitation'], {
          queryParams: { qrString: result.qrString }
        });
      }
    });
  }

}

